import React from 'react';
import c from 'classnames';
import { useSearchBox } from 'react-instantsearch';
import { SearchBarProps } from '@uncinc/react-searchkit/dist/components/SearchBar';

import SearchBar from '../../Search/Bar';
import './style.scss';

const SearchAllContentSearchBar: React.FC<SearchBarProps> = (props) => {
  const {
    className,
    ...restProps
  } = props;

  const searchbox = useSearchBox();

  const classNames = c('SearchAllContent__SearchBar', className);

  return (
    <>
      <span className="SearchAllContent__SearchBar__title">Zoekresultaten voor {searchbox.query}</span>
      <SearchBar
        {...restProps}
        className={classNames}
      />
    </>
  );
};

export default SearchAllContentSearchBar;
